import { createStore, compose, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";

import rootReducer from "./reducers";
import rootSaga from "./sagas";

import middlewares, { sagaMiddleware } from "./middlewares";


export default (initialState = {}) => {

	let store;

	if(import.meta.env.PROD){

		store = createStore(
			rootReducer,
			initialState,
			compose(applyMiddleware(...middlewares))
		);

	} else {

		store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)));

	}

	sagaMiddleware.run(rootSaga);

	return store;

};
